<button mat-icon-button
        [ngClass]="buttonClasses"
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel || null"
        [disableRipple]="disableRipple"
        [matMenuTriggerFor]="menuTrigger"
        (click)="onClick($event)">
    <cs-icon [csIcon]="csIcon"
             [icon]="icon"/>
    <ng-content/>
</button>
